import DesiredUseCase from './DesiredUseCase';

export default DesiredUseCase;
